import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6 text-center">
      <div className="mb-10"><Logo /></div>
      <div className="max-w-md rounded-xl border border-border/70 bg-card/50 p-10">
        <XCircle className="h-12 w-12 text-muted-foreground mx-auto" />
        <h1 className="font-display text-xl font-semibold mt-6">Checkout cancelled</h1>
        <p className="text-sm text-muted-foreground mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
        <div className="mt-8 flex gap-2 justify-center">
          <Button onClick={() => navigate("/")} variant="outline" className="rounded-md">Back to pricing</Button>
          <Button onClick={() => navigate("/app")} className="rounded-md bg-amber-500 text-black hover:bg-amber-400">Go to app</Button>
        </div>
      </div>
    </div>
  );
}
